import { Spin } from 'antd';
import React from 'react';
import { useFela } from 'react-fela';
import { Outlet } from 'react-router-dom';
import { FelaStyle } from 'src/fela';
import colors from '../../../commons/colors';

type UploadCertificateVerificationProps = {
  loading: boolean;
};

export default function UploadCertificateVerification({
  loading,
}: UploadCertificateVerificationProps) {
  const { css } = useFela();

  return (
    <div className={css(styles.wrapper)}>
      <div className={css(styles.container)}>
        <Spin spinning={loading}>
          <Outlet />
        </Spin>
      </div>
    </div>
  );
}

const styles: FelaStyle = {
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: colors.mywork.lightOrange,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1.5rem',
    width: '100%',
    height: '100vh',
    maxWidth: '31.25rem',
    backgroundColor: colors.mywork.neutral,
  },
};
